import AddressBarWrapper from './AddressBarWrapper';

export default AddressBarWrapper;
